// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2690":"070a4d19","2833":"45ac1b42","3904":"45ac1b42"}[chunkId] + ".chunk.css";
};